// 📁 src/admin/users/UserDetails.js
import React from 'react';
import { useParams } from 'react-router-dom';

const UserDetails = () => {
  const { id } = useParams();

  return (
    <div>
      <h2>User Details</h2>
      <p>Details for user ID: {id}</p>
    </div>
  );
};

export default UserDetails;